export default "/institutions/pnc.svg";